/**
 * Resuelve qué bloques del formulario de creación/envío de tarea deben mostrarse
 * según modeloTarea.appFields (alineado con la idea de ModeloTareaForm:
 * si appFields.enabled === true se usan los flags guardados; si no, defaults en app).
 *
 * Rama "campos deshabilitados" (enabled !== true): planificación y fechas solo
 * si el usuario tiene un rol cuyo nombre coincide con /^admin/i (admin, administrador, …).
 */
export function hasAdminLikeAppFieldsRole(roles: string[] | undefined | null) {
  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }
  return roles.some((r) => /^admin/i.test(String(r).trim()));
}

export type ResolvedModeloTareaAppFields = {
  enabled?: boolean;
  planification: boolean;
  currentUserAssign: boolean;
  currentUserValidate: boolean;
  currentUserAccept: boolean;
  validators: boolean;
  acceptors: boolean;
  assets: boolean;
  tercero: boolean;
  startDate: boolean;
  endDate: boolean;
  dirigidoA: boolean;
  defaultTipoTercero?: string;
  defaultAssetGroup?: string;
  inheritParentTaskValidators?: boolean;
  addActivity?: boolean;
  createNewTask?: boolean;
};

function flagsWhenEnabledTrue(
  raw: Record<string, any>,
): ResolvedModeloTareaAppFields {
  return {
    enabled: true,
    planification: Boolean(raw.planification),
    currentUserAssign: Boolean(raw.currentUserAssign),
    currentUserValidate: Boolean(raw.currentUserValidate),
    currentUserAccept: Boolean(raw.currentUserAccept),
    validators: Boolean(raw.validators),
    acceptors: Boolean(raw.acceptors),
    assets: Boolean(raw.assets),
    tercero: Boolean(raw.tercero),
    startDate: Boolean(raw.startDate),
    endDate: Boolean(raw.endDate),
    dirigidoA: Boolean(raw.dirigidoA),
    defaultTipoTercero: raw.defaultTipoTercero,
    defaultAssetGroup: raw.defaultAssetGroup,
    inheritParentTaskValidators: Boolean(raw.inheritParentTaskValidators),
    addActivity: Boolean(raw.addActivity),
    createNewTask: Boolean(raw.createNewTask),
  };
}

export const LEGACY_ALL_VISIBLE_APP_FIELDS: ResolvedModeloTareaAppFields = {
  planification: true,
  currentUserAssign: true,
  currentUserValidate: true,
  currentUserAccept: true,
  validators: true,
  acceptors: true,
  assets: true,
  tercero: true,
  startDate: true,
  endDate: true,
  // dirigidoA es opt-in: solo visible si se habilita explícitamente en appFields
  dirigidoA: false,
};

export const DEFAULT_APP_FIELDS: ResolvedModeloTareaAppFields = {
  planification: false,
  currentUserAssign: false,
  currentUserValidate: false,
  currentUserAccept: false,
  validators: false,
  acceptors: false,
  assets: false,
  tercero: false,
  startDate: false,
  endDate: false,
  dirigidoA: false,
};

export function resolveModeloTareaAppFieldsForCreate(
  raw: Record<string, any> | null | undefined,
  roles: string[] | undefined | null,
): ResolvedModeloTareaAppFields {
  if (raw == null) {
    return {...LEGACY_ALL_VISIBLE_APP_FIELDS};
  }

  if (raw.enabled === true) {
    return flagsWhenEnabledTrue(raw);
  }

  const isAdmin = hasAdminLikeAppFieldsRole(roles);
  return {
    ...DEFAULT_APP_FIELDS,
    enabled: true,
    currentUserAssign: true,
    currentUserValidate: isAdmin,
    currentUserAccept: isAdmin,
    validators: true,
    acceptors: true,
    planification: isAdmin,
    startDate: isAdmin,
    endDate: isAdmin,
  };
}
